import React, { useEffect, useState, useMemo } from "react";
import { Modal, Checkbox, Input, Tooltip, Button, Tabs } from "antd";
import { useSelector, useDispatch } from "react-redux";
import PersonalInfo from "./PersonalInfo";
import ChangePassword from "./ChangePassword";
import KeyExecutives from "./KeyExecutives";
const UserInfoContent = () => {
  const dispatch = useDispatch();
  const [tabActiveKey, setTabActiveKey] = useState("1");

  const items = [
    {
      key: "1",
      label: (
        <span>
          <i className=" pr-1 fs-18 las la-user-tie"></i>Personal Info
        </span>
      ),
      children: <PersonalInfo />,
    },
    {
      key: "2",
      label: (
        <span>
          <i className=" pr-1 fs-18 las la-user-lock"></i>Change Password
        </span>
      ),
      children: <ChangePassword />,
    },
    {
      key: "3",
      label: (
        <span>
          <i className=" pr-1 fs-18 las la-user-check"></i>Account Info
        </span>
      ),
      // children: <KeyExecutives />,
    },
    {
      key: "4",
      label: (
        <span>
          <i className=" pr-1 fs-18 las la-file-invoice"></i>Invoices
        </span>
      ),
      // children: <KeyExecutives />,
    },
    {
      key: "5",
      label: (
        <span>
          <i className=" pr-1 fs-18 las la-file-alt"></i>Billing
        </span>
      ),
      // children: <KeyExecutives />,
    },
    {
      key: "6",
      label: (
        <span>
          <i className=" pr-1 fs-18 las la-history"></i>Download History
        </span>
      ),
      // children: <KeyExecutives />,
    },
  ];
  const onChange = (key) => {
    setTabActiveKey(key);
  };
  return (
    <>
      <div className="row">
        <div id="executive" className="col-md-12">
          <div className="mt-4 mb-4">
            <div className="buttons-c mr-3"></div>
            <div className="">
              <Tabs
                // defaultActiveKey="1"
                activeKey={tabActiveKey}
                items={items}
                onChange={onChange}
                type="card"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserInfoContent;
